export const EXPLORE_PAGE_COURSERA_PLUS_CAMPAIGN_SLUGS = [
  'genai-for-software-development',
  'genai-for-your-career',
  'genai-for-data-science',
  'data-career-hub',
  'developer-career-hub',
];
